import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import type { CardKindViewType } from '@web/widgets/product-card/type';
import { type CardSettingsFormGroup } from '@web/widgets/product-card/type';
import { type CardSettingsFormType } from '@web/widgets/product-card/type/product-card-form.type';
import { TranslateModule } from '@ngx-translate/core';
import { ProductVariantsSettingsComponent } from '../common-settings/product-variants-settings/product-variants-settings.component';
import { TypographySettingsComponent } from '../common-settings/typography-settings/typography-settings.component';
import { GallerySettingsComponent } from '../common-settings/gallery-settings/gallery-settings.component';
import { GeneralSettingsComponent } from '../common-settings/general-settings/general-settings.component';
import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';

@Component({
    selector: 'web-product-settings',
    templateUrl: './product-settings.component.html',
    styleUrls: ['./product-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        WebSettingsModule,
        GeneralSettingsComponent,
        GallerySettingsComponent,
        TypographySettingsComponent,
        ProductVariantsSettingsComponent,
        TranslateModule,
    ],
})
export class ProductSettingsComponent extends WebBaseControlTypedSettingsComponent<CardSettingsFormGroup> {
    @Input() public widgetId: string;
    @Input() public cardKindViewType: CardKindViewType;

    public get generalSettingsFormGroup(): CardSettingsFormType['general'] {
        return this.itemForm.get('general') as CardSettingsFormType['general'];
    }

    public get gallerySettingsFormGroup(): CardSettingsFormType['gallery'] {
        return this.itemForm.get('gallery') as CardSettingsFormType['gallery'];
    }

    public get infoSettingsFormGroup(): CardSettingsFormType['info'] {
        return this.itemForm.get('info') as CardSettingsFormType['info'];
    }

    public get typographySettingsFormGroup(): CardSettingsFormType['typography'] {
        return this.itemForm.get('typography') as CardSettingsFormType['typography'];
    }

    public get productVariantsSettingsFormGroup(): CardSettingsFormType['productVariants'] {
        return this.itemForm.get('productVariants') as CardSettingsFormType['productVariants'];
    }
}
